export default __webpack_public_path__ + "static/calendar-1708c38f4f9c3642d6d0b56c251d764f.jpg";